export interface IDepositSalesTicket {
  salesId: string;
  ticketNo: string;
  depositSeqNo: string;
  agentId: string;
  agentName: string;
  inboundFlag: string;
  prefectureId?: string;
  registrationDate: Date;
  ticketReserveTime?: Date;
  startDate?: Date;
  limitMonthDate?: Date;
  mdTdTicketType: string;
  mdTdTicketTypeName: string;
  priceSystemId: string;
  ticketUid: string;
  ticketId: string;
  priceType: string;
  ticketType: string;
  ticketDisplayName: string;
  unitPrice: number;
  ticketSpecType: string;
  displayOrder: string;
  count: number;
  cashTotal: number;
  ticketReserveStatus: string;
  ticketReserveStatusEnum: string;
  ticketReserveStatusName: string;
  ticketReserveType: string;
  ticketReserveTypeEnum: string;
  ticketReserveTypeName: string;
  deleteFlagEnum: string;
}

export class DepositSalesTicketFormValues implements IDepositSalesTicket {
  salesId: string = '';
  ticketNo: string = '';
  depositSeqNo: string = '';
  agentId: string = '';
  agentName: string = '';
  inboundFlag: string = '';
  prefectureId?: string = '';
  registrationDate: Date = new Date();
  ticketReserveTime?: Date = undefined;
  startDate?: Date = undefined;
  limitMonthDate?: Date = undefined;
  mdTdTicketType: string = '';
  mdTdTicketTypeName: string = '';
  priceSystemId: string = '';
  ticketUid: string = '';
  ticketId: string = '';
  priceType: string = '';
  ticketType: string = '';
  ticketDisplayName: string = '';
  unitPrice: number = 0;
  ticketSpecType: string = '';
  displayOrder: string = '';
  count: number = 0;
  cashTotal: number = 0;
  ticketReserveStatus: string = '';
  ticketReserveStatusEnum: string = '';
  ticketReserveStatusName: string = '';
  ticketReserveType: string = '';
  ticketReserveTypeEnum: string = '';
  ticketReserveTypeName: string = '';
  deleteFlagEnum: string = '';

  constructor(init?: IDepositSalesTicket) {
    Object.assign(this, init);
  }
}

export interface IDepositSalesTicketFilters {
  depositStartDate?: string;
  depositSeqNo?: string;
  agentId?: string;
  agentName?: string;
  registrationDateFrom?: Date;
  registrationDateTo?: Date;
  ticketReserveTimeFrom?: Date;
  ticketReserveTimeTo?: Date;
  startDate?: Date;
  limitMonthDate?: Date;
  mdTdTicketType?: string;
  mdTdTicketTypeName?: string;
  ticketReserveStatus?: string;
  ticketReserveStatusName?: string;
  ticketReserveType?: string;
  ticketReserveTypeName?: string;
}

export class DepositSalesTicketFiltersFormValues
  implements IDepositSalesTicketFilters {
  depositStartDate?: string = undefined;
  depositSeqNo?: string = undefined;
  agentId?: string = undefined;
  agentName?: string = undefined;
  registrationDateFrom?: Date = undefined;
  registrationDateTo?: Date = undefined;
  ticketReserveTimeFrom?: Date = undefined;
  ticketReserveTimeTo?: Date = undefined;
  startDate?: Date = undefined;
  limitMonthDate?: Date = undefined;
  mdTdTicketType?: string = undefined;
  mdTdTicketTypeName?: string = undefined;
  ticketReserveStatus?: string = undefined;
  ticketReserveStatusName?: string = undefined;
  ticketReserveType?: string = undefined;
  ticketReserveTypeName?: string = undefined;

  constructor(init?: IDepositSalesTicketFilters) {
    Object.assign(this, init);
  }
}

export interface IDepositSalesTicketPrint {
  depositSalesTicketPrintId: string;
  ticketPrintStatus: string;
  ticketPrintStatusEnum: string;
  ticketPrintStatusName: string;
  ticketFileUri: string;
  ticketReserveClerkName: string;
  ticketReserveTime: Date;
  ticketNo: string;
  count: number;
}
